document.addEventListener('DOMContentLoaded', function () {
    const searchInputTriggers = document.querySelectorAll('.site-header__search-input');
    const searchInputs = document.querySelectorAll('.search__input[type="search"]');

    if (searchInputs.length > 0) {
        const focusInput = () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                const inputToFocus = window.innerWidth < 650 ? searchInputs[1] : searchInputs[0];
                inputToFocus.focus();
                inputToFocus.click();
                const valueLength = inputToFocus.value.length;
                inputToFocus.setSelectionRange(valueLength, valueLength);
            }, 500);
        };

        searchInputTriggers.forEach(el => {
            el.addEventListener('click', focusInput);
            el.addEventListener('focus', focusInput);
        });
    } else {
        console.error('No se encontraron los elementos necesarios.');
    }
});

document.addEventListener('DOMContentLoaded', function () {

    document.body.setAttribute('data-test', "A")
})